// extracted by mini-css-extract-plugin
export default {"loffaAccountSettings":"AccountSettings_loffaAccountSettings__snTk6"};